import CreatePlan from './CreatePlan';

export default CreatePlan;
